/**
 * Home component
 *
 * The section at the top of the page to display image of your
 * choice, name and title that describes your career focus.
 */

import React from "react";
import arrowSvg from "url:../images/down-arrow.svg";
import PropTypes from "prop-types";

/**
 * Home background image
 *
 * Below is a sample image. Upload the image of your choice into the "images"
 * directory and import here for use. Then, set imageAltText to string that 
 * represents what you see in that image.
 *
 *
 * Need an image? Check out https://unsplash.com to download a photo you
 * freely use on your site.
 */
const image = "https://www.brainvire.com/blog/wp-content/uploads/2024/09/AI-In-Cloud-Computing-Is-Bringing-Efficiency-And-Scalability.webp";

const imageAltText = "AI in cloud computing bringing efficiency and scalability with digital technology infrastructure";

const Home = ({ name = "", title = "" }) => {
  return (
    <section id="home" className="min-height">
      <img className="background" src={image} alt="" />
      <div style={{
        position: "absolute",
        top: "5rem",
        left: "clamp(1rem, 4vw, 3rem)",
        width: "clamp(12rem, 40vw, 20rem)",
      }}>
        <h1 style={{ color: "white" }}>{name}</h1>
        <h2 style={{ color: "white" }}>{title}</h2>
      </div>
      <div
        style={{ position: "absolute", bottom: "3rem", left: "50%", transform: "translateX(-50%)", cursor: "pointer" }}
        onClick={() => document.getElementById("chatbot")?.scrollIntoView({ behavior: "smooth" })}
        role="button"
        tabIndex="-1"
        aria-label="Scroll to Chat section"
      >
        <img src={arrowSvg} style={{ height: "3rem", width: "3rem" }} alt="Scroll down" />
      </div>
    </section>
  );
};

Home.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Home;
